<template>
    <div class="container">
        <div id="mjmlGjs"></div>
        <div class="modal fade" ref="saveEmailTemplateModal" id="saveEmailTemplateModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document" style="max-width:720px!important">
                <div class="modal-content">
                    <div class="modal-content">
                        <div class="save-template-wrapper">
                            <div class="row">
                                <div class="col-md-3">
                                    <label>Şablon adı</label>
                                </div>
                                <div class="col-md-6">
                                    <input class="full-width form-control" v-model="emailTemplateName">
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-3">
                                    <label>Email Konusu
                                    </label>
                                </div>
                                <div class="col-md-6">
                                    <input class="full-width form-control" v-model="emailTemplateSubject">
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-3">
                                    <label>Email Önizleme Metni
                                    </label>
                                </div>
                                <div class="col-md-6">
                                    <input class="full-width form-control" v-model="emailTemplatePreviewText">
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-9">
                                    <button class="pull-right btn btn-secondary sablon" @click="saveEmailTemplate()">Şablonu Kaydet</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
const grapesjs = require("grapesjs");
import grapesJSMJML from 'grapesjs-mjml'
import grapesJSPluginCKEditor from 'grapesjs-plugin-ckeditor'
import axios from 'axios'

import {mapState} from 'vuex'
import {mapActions} from 'vuex'
import {mapGetters} from 'vuex'

export default {
    name: "wfEmailTemplateEditor",
    data() {
        return {
            emailTemplateName: '',
            emailTemplateSubject: '',
            emailTemplatePreviewText: '',
            emailTemplateId: this.$route.params.emailTemplateId
        };
    },
    computed: {
        ...mapState([
            'baseUrl'
        ])
    },
    methods: {
        saveEmailTemplate () {
            $('#saveEmailTemplateModal').modal('hide')
            axios({
                method:'POST',
                url:'/saveEmailWorkflowTemplate',
                baseURL: this.baseUrl,
                data: {
                    emailTemplateName: this.emailTemplateName,
                    emailTemplateSubject: this.emailTemplateSubject,
                    emailTemplatePreviewText: this.emailTemplatePreviewText,
                    emailTemplateHtml: this.editor.runCommand('mjml-get-code').html,
                    emailTemplateMjml: this.editor.getHtml(),
                    emailTemplateAssets: this.editor.AssetManager.getAll()
                },
                withCredentials:true
            }).catch(function (error) {
                alert("Kaydederken hata oldu")
                console.log(error);
            }).then((res)=>{
                return res
            }).then((res)=>{
                if(res.data.status.code==="0"){
                    console.log("Islem basarili!")
                }else{
                    alert("Kaydederken hata oldu")
                    console.log(error);
                }
            })
        },
        getEmailTemplate () {
            if (this.emailTemplateId === 'new') {
                console.log('new template')
            } else {
                axios({
                    method:'POST',
                    url:'/getEmailWorkflowTemplate',
                    baseURL: this.baseUrl,
                    data: {
                        emailTemplateId: this.emailTemplateId
                    },
                    withCredentials:true
                }).then((res)=>{
                    return res
                }).then((res)=>{
                    if(res.data.status.code==="0"){
                        this.editor.setComponents(res.data.content.email_workflow_template.mjml);
                        this.emailTemplateName = res.data.content.email_workflow_template.name
                        this.emailTemplateSubject = res.data.content.email_workflow_template.subject
                        this.emailTemplatePreviewText = res.data.content.email_workflow_template.previewText

                        if (res.data.content.email_workflow_template.hasOwnProperty('assets')) {
                            console.log(res.data.content.email_workflow_template.assets);
                            this.editor.AssetManager.load({
	                            assets: res.data.content.email_workflow_template.assets
                            })
                        }
                    } else {
                        this.$notify({
                            group: 'foo',
                            type: 'error',
                            title: this.$ml.get('ERROR'),
                            text: res.data.status.desc
                        })
                        // this.editor.setComponents("")
                        console.log('new template')
                    }
                })
            }
        },
    },
    mounted(){
        CKEDITOR.plugins.addExternal( 'spacingsliders', '/static/ckeditor/plugins/spacingsliders/plugin.js' );
        CKEDITOR.plugins.addExternal( 'wfEmailTemplateContentParameterList', '/static/ckeditor/plugins/wfEmailTemplateContentParameterList/plugin.js' );

        this.editor = grapesjs.init({
            container: '#mjmlGjs',
            storageManager: {
                id: 'mjmlGjs-',
                autoload: 1
            },
	        noticeOnUnload: 0,
            assetManager: {
                upload: 'https://live.minimumcrm.com/pc-api/storeImages',
                autoAdd: true,
                uploadName: 'files',
                assets: [],
                uploadText: 'Görseli buraya sürükleyin ya da tıklayarak seçim yapın.',
                modalTitle: 'Görsel seçimi',
            },
            styleManager: {
                textNoElement: 'Stil Yöneticisini kullanabilmek için, bir öğe seçiniz.'
            },
	        fromElement: true,
	        plugins: [
                grapesJSPluginCKEditor,
                grapesJSMJML
            ],
	        pluginsOpts: {
                [grapesJSMJML]: {},
	            [grapesJSPluginCKEditor]: {
                    position: 'center',
                    options: {
                        startupFocus: true,
                        extraAllowedContent: '*(*);*{*}', // Allows any class and any inline style
                        allowedContent: true, // Disable auto-formatting, class removing, etc.
                        enterMode: CKEDITOR.ENTER_BR,
                        removePlugins : 'magicline',
                        /* extraPlugins: 'sharedspace,colorbutton,panelbutton,font,contentParameterList,pastetext,justify,spacingsliders', */
                        extraPlugins: 'sharedspace,colorbutton,panelbutton,font,pastetext,justify,wfEmailTemplateContentParameterList,spacingsliders',
                        toolbar: [
                            { name: 'styles', items: ['Font', 'FontSize','contentParameterList' ] },
                            ['Bold', 'Italic', 'Underline', 'Strike'],
                            {name: 'paragraph', items : [ 'NumberedList', 'BulletedList']},
                            {name: 'links', items: ['Link', 'Unlink']},
                            {name: 'colors', items: [ 'TextColor', 'BGColor' ]},
                            {name: 'justify', items: [ 'JustifyLeft','JustifyCenter','JustifyRight','JustifyBlock']},
                            {name: 'spacingsliders',items:['spacingsliders']},

                        ],
                        forcePasteAsPlainText : true,
                    }
                }
	        }
        });

        this.editor.DomComponents.addType('mj-group', {
            model: {
                defaults: {
                    name: 'Grup'
                }
            }
        });

        this.editor.DomComponents.addType('mj-wrapper', {
            model: {
                defaults: {
                    name: 'Kutu'
                }
            }
        });
        this.editor.DomComponents.addType('mj-section', {
            model: {
                defaults: {
                    name: 'Yatay Alan'
                }
            }
        });
        this.editor.DomComponents.addType('mj-column', {
            model: {
                defaults: {
                    name: 'Kolon'
                }

            }
        });
        this.editor.DomComponents.addType('mj-text', {
            model: {
                defaults: {
                    name: 'Yazı',
                    stylable: [
                        'height',
                        'line-height', 'letter-spacing', 'text-decoration', 'align', 'text-transform',
                        'padding', 'padding-top', 'padding-left', 'padding-right', 'padding-bottom',
                        'container-background-color'
                    ]
                }
            }
        });
        this.editor.DomComponents.addType('mj-wrapped-text', {
            model: {
                defaults: {
                    name: 'Kutulu Yazı'
                }
            }
        });
        this.editor.DomComponents.addType('mj-button', {
            model: {
                defaults: {
                    name: 'Buton'
                }
            }
        });
        this.editor.DomComponents.addType('mj-image', {
            model: {
                defaults: {
                    name: 'Görsel',
                    void: false
                }
            }
        });
        this.editor.DomComponents.addType('mj-image-card', {
            model: {
                defaults: {
                    name: 'Görsel Kartı'
                }
            }
        });
        this.editor.DomComponents.addType('mj-image-text', {
            model: {
                defaults: {
                    name: 'Görsel + Yazı'
                }
            }
        });
        this.editor.DomComponents.addType('mj-image-group', {
            model: {
                defaults: {
                    name: 'Görsel Grubu'
                }
            }
        });
        this.editor.DomComponents.addType('mj-divider', {
            model: {
                defaults: {
                    name: 'Ayıraç'
                }
            }
        });
        this.editor.DomComponents.addType('mj-social', {
            model: {
                defaults: {
                    name: 'Sosyal Menü'
                }
            }
        });
        this.editor.DomComponents.addType('mj-social-element', {
            model: {
                defaults: {
                    name: 'Sosyal Link',
                    traits: [
                        {
                            type: 'select',
                            label: 'Icon',
                            name: 'name',
                            options: [
                                { value: '', name: 'Custom' },
                                { value: 'facebook-noshare', name: 'Facebook'},
                                { value: 'twitter-noshare', name: 'Twitter' },
                                { value: 'google-noshare', name: 'Google' },
                                { value: 'instagram-noshare', name: 'Instagram' },
                                { value: 'web-noshare', name: 'Web' },
                                { value: 'youtube-noshare', name: 'Youtube' },
                                { value: 'pinterest-noshare', name: 'Pinterest' },
                                { value: 'linkedin-noshare', name: 'Linkedin' },
                                { value: 'snapchat-noshare', name: 'Snapchat' },
                                { value: 'vimeo-noshare', name: 'Vimeo' },
                                { value: 'tumblr-noshare', name: 'Tumblr' },
                                { value: 'github-noshare', name: 'Github' },
                                { value: 'soundcloud-noshare', name: 'SoundCloud' },
                                { value: 'medium-noshare', name: 'Medium' },
                                { value: 'dribbble-noshare', name: 'Dribbble' },
                                { value: 'xing-noshare', name: 'Xing' },
                            ]
                        },
                        { name: 'src' },
                        { name: 'href' },
                    ],
                }
            }
        });

        // The upload is started
        this.editor.on('asset:upload:start', () => {
            var loadicon = '<i class="fa fa-spinner fa-spin" aria-hidden="true"></i>';
            var loadingbar = $('<div/>').html('Görsel Yükleniyor '+ loadicon).attr('id','loadbar');
            $('.gjs-am-assets').prepend(loadingbar);
        });

        // The upload is ended (completed or not)
        this.editor.on('asset:upload:end', () => {
            //falseMask();
            $('#loadbar').remove();
        });

        // Error handling
        this.editor.on('asset:upload:error', (err) => {
            //notifyError(err);
        });

        this.editor.DomComponents.addType('mj-spacer', {
            model: {
                defaults: {
                    name: 'Boşluk',
                    void: false
                }
            }
        });
        this.editor.DomComponents.addType('mj-navbar', {
            model: {
                defaults: {
                    name: 'Menü'
                }
            }
        });
        this.editor.DomComponents.addType('mj-navbar-link', {
            model: {
                defaults: {
                    name: 'Menü Link'
                }
            }
        });

        const bm = this.editor.BlockManager;
        const basicBlocks = {
            category: 'Temel Modüller',
        };
        const columnBlocks = {
            category: 'Kolonlar',
        };
        const readyBlocks = {
            category: 'Hazır Modüller',
        };
        const linkBlocks = {
            category: 'Hazır Linkler',
        };


        bm.add('mj-1-column', {
            label: 'Kolon',
            content: `
        <mj-section>
          <mj-column></mj-column>
        </mj-section>

            `,
            attributes: { class: 'font-5em icon-kolon1' },
            ...columnBlocks,
        });

        bm.add('mj-2-column', {
            label: '2 Kolon',
            content: `
        <mj-section>
          <mj-column></mj-column>
          <mj-column></mj-column>
        </mj-section>
            `,
            attributes: { class: 'font-5em icon-kolon2' },
            ...columnBlocks,
        });

        bm.add('mj-3-column', {
            label: '3 Kolon',
            content: `
        <mj-section>
          <mj-column></mj-column>
          <mj-column></mj-column>
          <mj-column></mj-column>
        </mj-section>
            `,
            attributes: { class: 'font-5em icon-kolon3' },
            ...columnBlocks,
        });

        bm.add('mj-4-column', {
            label: '4 Kolon',
            content: `
        <mj-section>
          <mj-column></mj-column>
          <mj-column></mj-column>
          <mj-column></mj-column>
          <mj-column></mj-column>
        </mj-section>
            `,
            attributes: { class: 'font-5em icon-kolon4' },
            ...columnBlocks,
        });

        bm.add('mj-5-column', {
            label: '5 Kolon',
            content: `
        <mj-section>
          <mj-column></mj-column>
          <mj-column></mj-column>
          <mj-column></mj-column>
          <mj-column></mj-column>
          <mj-column></mj-column>
        </mj-section>
            `,
            attributes: { class: 'font-5em icon-kolon5' },
            ...columnBlocks,
        });

        bm.add('mj-6-column', {
            label: '6 Kolon',
            content: `
        <mj-section>
          <mj-column></mj-column>
          <mj-column></mj-column>
          <mj-column></mj-column>
          <mj-column></mj-column>
          <mj-column></mj-column>
          <mj-column></mj-column>
        </mj-section>
            `,
            attributes: { class: 'font-5em icon-kolon6' },
            ...columnBlocks,
        });

        bm.add('mj-text', {
            label: 'Yazı',
            content: '<mj-text line-height="150%">İçerik yazılarınızı, üzerine çift tıklayarak düzenleyebilirsiniz.</mj-text>',
            attributes: { class: 'gjs-fonts gjs-f-text' },
            ...basicBlocks,
        });

        bm.add('mj-wrapped-text', {
            label: 'Kutulu Yazı',
            content: `
      <mj-section background-color="#9d9d9d" border="1px solid #000000" padding="10px">
        <mj-column>
          <mj-text line-height="150%">Yatay alanın arkaplan ve çerçeve rengini değiştirmek için stil yöneticisini kullanabilirsiniz.</mj-text>
        </mj-column>
      </mj-section>
            `,
            attributes: { class: 'fa fa-file-text-o' },
            ...readyBlocks,
        });

        bm.add('mj-button', {
            label: 'Buton',
            content: '<mj-button>Buton</mj-button>',
            attributes: { class: 'gjs-fonts gjs-f-button' },
            ...basicBlocks,
        });

        bm.add('mj-image', {
            label: 'Görsel',
            content: '<mj-image src="https://cdn.imdlv.net/images/placehold/350x250-78c5d6-fff.gif" />',
            attributes: { class: 'fa fa-image' },
            ...basicBlocks,
        });

        bm.add('mj-image-card', {
            label: 'Görsel Kartı',
            content: `
      <mj-section>
        <mj-column>
          <mj-image src="https://cdn.imdlv.net/images/placehold/350x250-78c5d6-fff.gif"></mj-image>
          <mj-text line-height="150%">İletişim Makinesi ile hazırladığınız e-postalar çeşitli ekran ölçülerine duyarlıdır.</mj-text>
        </mj-column>
        <mj-column>
          <mj-image src="https://cdn.imdlv.net/images/placehold/350x250-78c5d6-fff.gif"></mj-image>
          <mj-text line-height="150%">İletişim Makinesi ile hazırladığınız e-postalar çeşitli ekran ölçülerine duyarlıdır.</mj-text>
        </mj-column>
      </mj-section>
            `,
            attributes: { class: 'fa fa-image' },
            ...readyBlocks,
        });

        bm.add('mj-image-text', {
            label: 'Görsel + Yazı',
            content: `
      <mj-section>
        <mj-column>
          <mj-image src="https://cdn.imdlv.net/images/placehold/350x250-78c5d6-fff.gif">
        </mj-column>
        <mj-column>
          <mj-text line-height="150%">Kolon taşıma ile resim ve yazının yerlerini değiştirebilirsiniz.</mj-text>
        </mj-column>
      </mj-section>`,
            attributes: { class: 'fa fa-id-card-o' },
            ...readyBlocks,
        });

        bm.add('mj-image-group', {
            label: 'Görsel Grubu',
            content: `
      <mj-section>
        <mj-column>
          <mj-image src="https://cdn.imdlv.net/images/placehold/350x250-78c5d6-fff.gif">
        </mj-column>
        <mj-column>
          <mj-image src="https://cdn.imdlv.net/images/placehold/350x250-78c5d6-fff.gif">
        </mj-column>
      </mj-section>
      <mj-section>
        <mj-column>
          <mj-image src="https://cdn.imdlv.net/images/placehold/350x250-78c5d6-fff.gif">
        </mj-column>
        <mj-column>
          <mj-image src="https://cdn.imdlv.net/images/placehold/350x250-78c5d6-fff.gif">
        </mj-column>
      </mj-section>
            `,
            attributes: { class: 'fa fa-th-large' },
            ...readyBlocks,
        });

        bm.add('mj-divider', {
            label: 'Ayıraç',
            content: '<mj-divider/>',
            attributes: { class: 'gjs-fonts gjs-f-divider' },
            ...basicBlocks,
        });

        bm.add('mj-social-group', {
            label: 'Sosyal Menü',
            content: `<mj-social font-size="12px" icon-size="24px" border-radius="12px" mode="horizontal">
        <mj-social-element name="facebook-noshare" alt="Facebook" title="Facebook"></mj-social-element>
        <mj-social-element name="google-noshare" alt="google" title="google"></mj-social-element>
        <mj-social-element name="twitter-noshare" alt="Twitter" title="Twitter"></mj-social-element>
      </mj-social>`,
            attributes: { class: 'fa fa-share-alt' },
            ...basicBlocks,
        });

        bm.add('mj-social-element', {
            label: 'Sosyal Link',
            content: '<mj-social-element name="facebook-noshare" alt="Facebook" title="Facebook" />',
            attributes: { class: 'fa fa-share-alt' },
            ...basicBlocks,
        });

        bm.add('mj-spacer', {
            label: 'Boşluk',
            content: '<mj-spacer/>',
            attributes: { class: 'fa fa-arrows-v' },
            ...basicBlocks,
        });

        bm.add('mj-navbar', {
            label: 'Menü',
            content: `<mj-navbar>
    <mj-navbar-link>Getting started</mj-navbar-link>
    <mj-navbar-link>Try it live</mj-navbar-link>
    <mj-navbar-link>Templates</mj-navbar-link>
    <mj-navbar-link>Components</mj-navbar-link>
    </mj-navbar>`,
            attributes: { class: 'fa fa-bars' },
            ...basicBlocks,
        });

        bm.add('mj-navbar-link', {
            label: 'Menü Link',
            content: `<mj-navbar-link>Link 1</mj-navbar-link>`,
            attributes: { class: 'gjs-fonts gjs-f-button' },
            ...basicBlocks,
        });

        bm.add('mj-arc-link', {
            label: 'Web`te Gör Linki',
            content: `<mj-text>Bu maili düzgün görüntüleyemiyorsanız
          <a data-cke-saved-href="*|ARCHIVE|*" href="*|ARCHIVE|*">tıklayınız</a>
        </mj-text>`,
            attributes: { class: 'fa fa-hand-pointer-o' },
            ...linkBlocks,
        });

        bm.add('mj-asrc', {
            label: 'Abonelikten Çıkış',
            content: `<mj-text>Abonelikten çıkmak için
          <a data-cke-saved-href="*|UNSUB|*" href="*|UNSUB|*">tıklayınız</a>
        </mj-text>`,
            attributes: { class: 'fa fa-ban' },
            ...linkBlocks,
        });

        bm.add('mj-list-adress', {
            label: 'Adres Defterine Ekle',
            content: `<mj-text>Günlük e-postaların Gelen Kutusuna düştüğünden emin olmak için *|LIST_ADDRESS|* adresini Adres Defterinize ekleyebilirsiniz.</mj-text>`,
            attributes: { class: 'fa fa-address-book-o' },
            ...linkBlocks,
        });

        const styleManager = this.editor.StyleManager;
        const sectors = this.editor.StyleManager.getSectors();

        this.editor.on('load', () => {
            sectors.reset();
            sectors.add([{
                name: 'Boyutlar',
                open: false,
                buildProps: ['width', 'height', 'max-width', 'min-height', 'margin', 'padding'],
                properties: [{
                    name:'Genişlik', property:'width'
                },{
                    name :'Yükseklik', property: 'height'
                },{
                    name :'Maksimum Genişlik', property: 'max-width'
                },{
                    name :'Minimum Yükseklik', property: 'min-height'
                },{
                    name: 'Dış Boşluk',
                    property: 'margin',
                    properties: [
                        { name: 'Üst', property: 'margin-top' },
                        { name: 'Sağ', property: 'margin-right' },
                        { name: 'Alt', property: 'margin-bottom' },
                        { name: 'Sol', property: 'margin-left' }
                    ],
                }, {
                    name:'İç Boşluk',
                    property: 'padding',
                    detached: true,
                    properties: [
                        { name: 'Üst', property: 'padding-top', defaults:'10' },
                        { name: 'Sağ', property: 'padding-right', defaults:'25' },
                        { name: 'Alt', property: 'padding-bottom', defaults: '10' },
                        { name: 'Sol', property: 'padding-left', defaults: '25' }
                    ],
                }, {
                    name:'İkon Boyutu',
                    property: 'icon-size',
                    type: 'integer',
                    defaults: '20px',
                    units: ['px', '%']
                }],
            }, {
                name: 'Dekorasyon',
                open: false,
                buildProps: ['background-color', 'container-background-color', 'background-url', 'background-repeat',
                             'background-size', 'border-radius', 'border'],
                properties: [{
                    name:'Arkaplan Rengi',property:'background-color'
                },{
                    name:'Arkaplan Tekrarı',property:'background-repeat'
                },{
                    name:'Arkaplan Boyutu',property:'background-size'
                },{
                    name: 'Arkaplan Rengi',
                    property: 'container-background-color',
                    type: 'color',
                }, {
                    name:'Arkaplan URL',
                    property: 'background-url',
                    type: 'file',
                }, {
                    name:'Oval Köşe',
                    property: 'border-radius',
                    properties: [
                        { name: 'Sol Üst', property: 'border-top-left-radius' },
                        { name: 'Sağ Üst', property: 'border-top-right-radius' },
                        { name: 'Sol Alt', property: 'border-bottom-left-radius' },
                        { name: 'Sağ Alt', property: 'border-bottom-right-radius' }
                    ],
                }, {
                    property: 'border',
                    name: 'Kenarlık',
                    properties: [
                        { name: 'Genişlik', property: 'border-width', type: 'integer', defaults:'0' },
                        { name: 'Stil', property: 'border-style', type: 'select', defaults:'none',
                          list: [
                              { value: 'none' },
                              { value: 'solid' },
                              { value: 'dotted' },
                              { value: 'dashed' },
                              { value: 'double' },
                              { value: 'groove' },
                              { value: 'ridge' },
                              { value: 'inset' },
                              { value: 'outset' }
                          ]
                        },
                        { name: 'Renk', property: 'border-color', type: 'color' },
                    ],
                }],
            }
            ]);
        });

        const panelManager = this.editor.Panels;

        this.groupBtn = this.editor.Panels.addButton('options',{
            id: 'groupbtn',
            className: 'fa fa-lock',
            command: 'addGroup',
            attributes: { title: 'Grup Ekle'},
            active: false
        })

        this.editor.on('component:selected',(comp) => {
            var compType = comp.attributes.type;
            if(compType=='mj-section'){
                var compx = comp.toHTML();
                if($(compx).has('mj-group').length>0){
                    this.groupBtn.set({ command: 'removeGroup', className: 'fa fa-unlock' , attributes : {title:'Grup Sil'}});
                }else{
                    this.groupBtn.set({ command: 'addGroup', className: 'fa fa-lock' , attributes : {title:'Grup Ekle'}});
                }
            }else{
                this.groupBtn.set({ command: 'addGroup', className: 'fa fa-lock' , attributes : {title:'Grup Ekle'}});
            }
        });
        
        this.editor.Panels.addButton('options', [{
            id: 'clear',
            className: 'fa fa-trash',
            command: 'clear',
            attributes: { title: 'Temizle'},
            active: false
        }, {
            id: 'preview',
            className: 'fa fa-eye',
            command: 'preview',
            attributes: { title: 'Ön İzleme'},
            active: false
        }]);

        const cmd = this.editor.Commands;

        const domComponents = this.editor.DomComponents;

        cmd.add('clear', {
            run(editor) {
                if(confirm('Editörü temizlemek istediğinize emin misiniz?')){
                    editor.setComponents('<mjml><mj-body><mj-section></mj-section></mj-body></mjml>');
                    this.emailTemplateName = '';
                    this.emailTemplateSubject = '';
                    this.emailTemplatePreviewText = '';
                }
            }
        });

        cmd.add('addGroup', {
            run(editor) {

                var nodeType = editor.getSelected().attributes.type;

                if(nodeType == 'mj-section'){
                    var nodea = editor.getSelected();
                    var nodex = editor.getSelected().toHTML();

                    var firstTag=nodex.split(">")[0];

                    var nodeText = $(nodex).html()

                    nodex = firstTag+"><mj-group>"+nodeText+"</mj-group></mj-section>"

                    const component = editor.getSelected();
                    const coll = component.collection;
                    const at = coll.indexOf(component);
                    coll.remove(component);
                    coll.add(nodex, { at });
                    this.groupBtn.set({ command: 'removeGroup', className: 'fa fa-unlock' , attributes : {title:'Grup Sil'}});
                }

            }
        });

        cmd.add('removeGroup', {
            run(editor) {

                var nodeType = editor.getSelected().attributes.type;

                if(nodeType == 'mj-section'){
                    var nodea = editor.getSelected();
                    var nodex = editor.getSelected().toHTML();

                    var firstTag=nodex.split(">")[0];

                    var innerNode = $(nodex+' mj-group').children().html();

                    var nodex = firstTag+">"+innerNode+"</mj-section>";

                    const component = editor.getSelected();
                    const coll = component.collection;
                    const at = coll.indexOf(component);
                    coll.remove(component);
                    coll.add(nodex, { at });

                    this.groupBtn.set({ command: 'addGroup', className: 'fa fa-lock' , attributes : {title:'Grup Ekle'}});
                }

            }
        });

        cmd.add('mobilee', {
            run(editor) {
                editor.setDevice('Mobile1');
            }
        });

        const modal = this.editor.Modal;

        var saveBtn = panelManager.addButton('views', {
            id: 'savebtn',
            className: 'fa fa-floppy-o',
            command: 'saveCmd',
            attributes: { title: 'Şablonu Kaydet'},
            active: false,
        });

        cmd.add('saveCmd', {
            run(editor) {
                (function($) {
                    $("#saveEmailTemplateModal").modal('show')
                }(jQuery));
            }
        });

        this.getEmailTemplate()
    }
};
</script>

<style>

@font-face {
    font-family: 'icomoon';
    src:  url('../assets/mjml-fonts/icomoon.eot?gln9jb');
    src:  url('../assets/mjml-fonts/icomoon.eot?gln9jb#iefix') format('embedded-opentype'),
    url('../assets/mjml-fonts/icomoon.ttf?gln9jb') format('truetype'),
    url('../assets/mjml-fonts/icomoon.woff?gln9jb') format('woff'),
    url('../assets/mjml-fonts/icomoon.svg?gln9jb#icomoon') format('svg');
    font-weight: normal;
    font-style: normal;
    font-display: block;
}

.gjs-c {
    background-repeat: no-repeat;
    background-position: 50% 30%;
}

.gjs-c::before{content:" ";}

.font-5em:before{
    font-size: 5em;
}

.icon-kolon1:before {
    content: "\e900";
}
.icon-kolon2:before {
    content: "\e901";
}
.icon-kolon3:before {
    content: "\e902";
}
.icon-kolon4:before {
    content: "\e903";
}
.icon-kolon5:before {
    content: "\e904";
}
.icon-kolon6:before {
    content: "\e905";
}
</style>
